import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudService } from 'src/app/core/services/data/crud.service';
import { allCurriculumsEndpoint, getByCurriculumIdClassEndpoint, getActiveSchoolYearEndpoint } from 'src/app/core/constants/endpoints.constant';
import { LoaderMessagingService } from 'src/app/core/services/messaging/loader-messaging.service';
import { Subject } from 'rxjs';
import { Curriculum } from 'src/app/core/models/curriculum.model';
import { takeUntil } from 'rxjs/operators';
import { ErrorHandlerService } from 'src/app/core/services/util/error-handler.service';
import { HeaderMessagingService } from 'src/app/core/services/messaging/header-messaging.service';
import { CURRICULUM } from 'src/app/core/constants/configuration/curriculum-constants.config';
import { VIEW_MODULE_NAME } from 'src/app/core/constants/configuration/common.constant';
import { DataCustomizerService } from 'src/app/core/services/util/data-customizer.service';
import { Class } from 'src/app/core/models/class.model';
import { CLASSES_PATH, CURRICULUMS_PATH, CURRICULUM_UPDATE_PATH } from 'src/app/core/constants/routes.constant';
import { FabButtonMessagingService } from 'src/app/core/services/messaging/fab-button-messaging.service';
import { UserService } from 'src/app/core/services/util/user.service';
import { homeRoutingPermissions } from "src/app/core/constants/configuration/role-constants.config";

@Component({
	selector: 'app-curriculum-view',
	templateUrl: './curriculum-view.component.html',
	styleUrls: ['./curriculum-view.component.scss']
})
export class CurriculumViewComponent implements OnInit, OnDestroy {

	unsubscribe: Subject<any> = new Subject();
	curriculum: Curriculum;
	classes: Class[];
	hasInitialized: boolean = false;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private crudService: CrudService,
		private loaderMessagingService: LoaderMessagingService,
		private errorHandlerService: ErrorHandlerService,
		private headerMessagingService: HeaderMessagingService,
		private dataCustomizerService: DataCustomizerService,
		private fabButtonMessagingService: FabButtonMessagingService,
    private userService: UserService,
	) {
		this.userService.checkRolePermission(CURRICULUMS_PATH, homeRoutingPermissions);
		this.headerMessagingService.setHeader(CURRICULUM, VIEW_MODULE_NAME, false, null);
	}

	ngOnInit() {
		this.loaderMessagingService.showPageLoader(true);
		this.findCurriculum(this.route.snapshot.paramMap.get('id'));
	}

	ngOnDestroy(): void {
		this.fabButtonMessagingService.sendMessage({ canEdit: false, path: null, id: null });
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	handleCompletion = (): void => {
		this.loaderMessagingService.showPageLoader(false);
	};

	get canView(): boolean {
		return this.curriculum && this.hasInitialized;
	}

	onLinkClick(id: number): void {
		this.router.navigate([CLASSES_PATH, id]);
	}

	// PUT ALL API CALL BELOW
	private findCurriculum(id: string): void {

		this.crudService
			.getById<Curriculum>(allCurriculumsEndpoint.concat(`/${id}`))
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(response => {
				if (response) {
					this.curriculum = this.dataCustomizerService.formatCurriculumDetailsDisplay(response);
					this.findClasses(response.id);
				}
			}, this.errorHandlerService.handleError);

	}

	private findClasses(id: number): void {

		this.crudService
			.getAllBy<Class>(getByCurriculumIdClassEndpoint.concat(`?curriculumId=${id}`))
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(response => {
				if (response) {
					this.classes = response;
					this.checkActiveSchoolYear();
				}
			}, this.errorHandlerService.handleError, this.handleCompletion);

	}

	private initFabMessage(): void {
		let roles = homeRoutingPermissions.find(route => route.path === CURRICULUMS_PATH);
		const message: any = { canEdit: this.userService.hasRole(roles ? roles.roles : []), path: CURRICULUM_UPDATE_PATH, id: this.curriculum.id };
		this.fabButtonMessagingService.sendMessage(message);
		this.hasInitialized = true;
	}

	private checkActiveSchoolYear() {
		this.crudService
		.getById<any>(getActiveSchoolYearEndpoint)
		.pipe(takeUntil(this.unsubscribe))
		.subscribe(response => {
			if (response) {
				if(this.curriculum.syCode >= response.schoolYear) {
					this.initFabMessage();
				} else {
					this.hasInitialized = true;
				}
			}
		}, this.errorHandlerService.handleError);
	}

}
